import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  lastModified: '',
  lastRequestTime: null,
  homeState: {
    isFetching: false,
    isFetched: false,
    isFailed: false,
    item: null,
    errorMessage: '',
  },
}

export const homeSlice = createSlice({
  name: 'home',
  initialState: initialState,
  reducers: {
    getHomePageRequest: (state: any) => {
      state.homeState.isFetching = true
      state.homeState.isFetched = false
      state.homeState.isFailed = false
      state.homeState.errorMessage = ''
    },
    getHomePageSuccess: (state: any, action) => {
      state.homeState.isFetching = false
      state.homeState.isFetched = true
      state.homeState.item = action.payload.item
    },
    getHomePageFailure: (state: any, action) => {
      state.homeState.isFetching = false
      state.homeState.isFetched = true
      state.homeState.isFailed = true
      state.homeState.errorMessage = action.payload.errorMessage
    },
  },
})

export const { getHomePageRequest, getHomePageSuccess, getHomePageFailure } =
  homeSlice.actions

export default homeSlice.reducer
